import React, { Component } from 'react';
import Layout from '../../Layouts/DefaultLayout';
import { Container, Jumbotron, InputGroup, FormControl, Row, Col, Tabs, Tab, Card, Accordion, Breadcrumb, Button } from "react-bootstrap";

import { otherApi } from "../../../api";
var _ = require('lodash');

class FAQViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
        }
        document.title = "Bridge Alliance | FAQs"
    }

    componentDidMount = async () => {
        this._searchFAQ("")
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }


    _searchFAQ = (text) => {
        let categorries = this.props.faq_categories;

        otherApi.fetchFAQData(text).then(resp => {
            let result = resp.data.fAQs.edges;

            let data = {};
            for (let i = 0; i < categorries.length; i++) {
                let cat = categorries[i].node;

                let ardata = _.filter(result, function (obj) {
                    let arval = obj.node.faq_categories.edges;

                    let resut_catobj = (arval.length > 0 ? arval[0].node : null)
                    if (resut_catobj !== null) {
                        return (resut_catobj.faq_categoryId === cat.faq_categoryId);
                    } else {
                        return false;
                    }

                });
                data[cat.slug] = ardata;
            }
            this.setState({ FAQData: data });
        });
    }
    _onchangeSearch = (e) => {
        this._searchFAQ(e.target.value);
    }

    render = () => {
        return (
            <Layout>
                    <Jumbotron>
                        <Container>
                            <Row>
                                <Col>
                                    <Breadcrumb>
                                        <Breadcrumb.Item href="/faq">FAQ</Breadcrumb.Item>
                                    </Breadcrumb>
                                    <h1 className="mb-3">FAQ</h1>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text id="inputGroup-sizing-sm"  ><i className="icon-search"></i></InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <FormControl
                                            placeholder="Search help articles"
                                            aria-label=""
                                            aria-describedby="basic-addon2"
                                            onChange={this._onchangeSearch}
                                        />
                                    </InputGroup>
                                </Col>
                            </Row>
                        </Container>
                    </Jumbotron>
                <Container>
                    <Row>
                        <Col>
                            <Tabs
                                id="controlled-tab-example"
                                activeKey={this.state.key}
                                onSelect={key => this.setState({ key })}
                                className="faq-tabs"
                            >
                                {this.props.faq_categories.map(function (val, i) {
                                    let node = val.node;
                                    return (this.renderTab(node));
                                }.bind(this))}
                            </Tabs>
                        </Col>
                    </Row>
                    <Row className="mb-4 mt-5">
                        <Col className="text-center">
                            <h5 className="mb-4">Didn’t find what you are looking for?</h5>
                            <Button href="/contact">Contact us</Button>
                        </Col>
                    </Row>
                </Container>
            </Layout>
        );
    };


    renderTab = (data) => {
        if (this.state.FAQData !== undefined) {
            let ardata = this.state.FAQData[data.slug];
            return (
                <Tab eventKey={data.faq_categoryId} title={data.name} key={data.faq_categoryId}>
                    <Accordion defaultActiveKey="0">
                        {ardata.map(function (val, i) {
                            let node=val.node;
                            return (
                                <Card key={i}>
                                    <Accordion.Toggle as={Card.Header} eventKey={node.id}>
                                        {node.title}
                                   </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={node.id}>
                                        <Card.Body><div dangerouslySetInnerHTML={{ __html: node.content }} /> </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            )
                        })}
                    </Accordion>
                </Tab>
            )
        }

        return (null);
    }


}


/* Export Component ==================================================================== */
export default FAQViewContainer;